// Simple process polyfill for browser environment
if (typeof window !== 'undefined') {
  // Create process object if it doesn't exist
  if (!window.process) {
    window.process = {};
  }
  
  // Create process.env if it doesn't exist
  if (!window.process.env) {
    window.process.env = {};
  }
  
  // Set NODE_ENV to development by default
  if (!window.process.env.NODE_ENV) {
    window.process.env.NODE_ENV = 'development';
  }
  
  // Add browser flag
  window.process.browser = true;
  
  // Add nextTick implementation
  if (!window.process.nextTick) {
    window.process.nextTick = function(callback) {
      setTimeout(callback, 0);
    };
  }
}

// Export the process object
export default typeof window !== 'undefined' ? window.process : {};
